module.exports = __webpack_public_path__ + "img/panda.3484d66c.png";